import script from "./RuleChange.vue?vue&type=script&setup=true&lang=ts"
export * from "./RuleChange.vue?vue&type=script&setup=true&lang=ts"

import "./RuleChange.vue?vue&type=style&index=0&id=6dfb9d4e&lang=scss"

const __exports__ = script;

export default __exports__